import React, { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

import { format } from "date-fns";
import { Dialog } from "primereact/dialog";
import TextField from "@material-ui/core/TextField";
import { FileUpload } from "primereact/fileupload";
import { Calendar } from "primereact/calendar";
import Checkbox from "@material-ui/core/Checkbox";
import { connect } from "react-redux";
import Moment from "react-moment";
import { ToastContainer, toast } from "react-toastify";
import { ExtraBenefitMasterActions } from "../../actions";
import tableRequest from "../../models/tableRequest";
import { MultiSelect } from 'primereact/multiselect';

// import { userTypeMasterActions } from '../../actions';
import Switch from "@material-ui/core/Switch";
import { Dropdown } from "primereact/dropdown";
import { TabView, TabPanel } from "primereact/tabview";
import FormControl from '@mui/material/FormControl';

import { loyalityschemeActions } from "../../actions/loyalityschemeAction";

const TABS = {
  ADD_BENEFIT: 0,
  ADD_GIFT: 1,
  ADD_CONTRACTOR_BENEFIT: 2,
  ADD_CONTRACTOR_GIFT: 3,
};

class ExtraBenefitMaster extends Component {
  constructor(props) {
    super(props);
    this.tblResponse = new tableRequest();
    this.tblResponse2 = new tableRequest();
    this.statusBodyTemplate = this.statusBodyTemplate.bind(this);
    this.actionBodyTemplate = this.actionBodyTemplate.bind(this);

    this.isUniqueGiftList = this.isUniqueGiftList.bind(this);

    // this.actionBodyTemplateSubCate = this.actionBodyTemplateSubCate.bind(this);
    this.switchToggleConfirm = this.switchToggleConfirm.bind(this);

    this.handleChange = this.handleChange.bind(this);
    this.openDialog = this.openDialog.bind(this);
    // this.openDialog2 = this.openDialog2.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.CreatedDateTemplate = this.CreatedDateTemplate.bind(this);
    this.UpdatedDateTemplate = this.UpdatedDateTemplate.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.resetForm2 = this.resetForm2.bind(this);
    this.onHide = this.onHide.bind(this);
    this.onHide2 = this.onHide2.bind(this);
    this.onPage = this.onPage.bind(this);
    this.onSort = this.onSort.bind(this);
    this.onPage2 = this.onPage2.bind(this);
    this.onSort2 = this.onSort.bind(this);
    this.uploadFiles = this.uploadFiles.bind(this);
    this.photoBodyTemplate = this.photoBodyTemplate.bind(this);
    this.photoBodyTemplateSubCate = this.photoBodyTemplateSubCate.bind(this);
    this.setImagePath = this.setImagePath.bind(this);
    this.setSubCateImagePath = this.setSubCateImagePath.bind(this);

    this.setImagePathContractor = this.setImagePathContractor.bind(this);
    this.setSubCateImagePathContractor = this.setSubCateImagePathContractor.bind(this);

    this.state = {
      showContractorModal: false,
      selectedContractors: [],

      
      details: [],
      expandedDescriptionGroupId: null,

      expandedRows: null, // will hold keys of expanded rows
      groupedCategoryData: [],
      contractor_groupId: [],

      activeIndex: TABS.ADD_BENEFIT, // Default tab
      // contractor_RoleId: null,
      contractor_RoleId: [],
      UserRoleData: [],

      // selectedCity: null,
      selectedCity: [],
      CityDropdownData: [],

      id: "",
      IsAdd: true,
      IsEdit: true,
      IsEdit2: true,
      ThreesholdValue: 0,
      LoyaltyPoints: 0,

      first: 0,
      first2: 0,
      rows: 10,
      rows2: 5,

      sliderImage: "",
      contractor_sliderImage: "",

      AddMoreGift: [{ key: "", value: "", IsClaimed: 0 }],
      AddMoreGiftContractor: [{ key: "", value: "", IsClaimed: 0 }],

      SubCateImage: "",
      SubCateImageContractor: "",

      totalRecords: 0,
      totalRecords2: 0,

      globalFilter: null,
      sortOrder: "",
      sortOrder2: "",

      buttonLabel: "Submit",
      formHeading: "Add Extra Benefit",

      switchAction: false,
      switchAction2: false,

      // Regular Benefit form values
      CategoryId: 0,
      MCategoryId: 0,
      SubCatId: 0,
      groupId: 0,
      quarterPeriod: "",
      FromDate: "",
      endDate: "",
      IsActive: true,
      CreatedDate: null,
      UpdatedDate: null,
      AdminUserId: 0,

      
      formError: {
        groupId: "",
        quarterPeriod: "",
        FromDate: "",
        endDate: "",
        sliderImage: "",
      }
      ,

      // Special Contractor Benefit form values
      // contractor_groupId: 0,
      contractor_groupId: [],
      contractor_FromDate: "",
      contractor_endDate: "",
      // contractor_RoleId: "",
      contractor_RoleId: [],
      contractor_sliderImage: "",
      contractor_shareurl: "",

      contractor_formError: {
        contractor_groupId: "",
        contractor_FromDate: "",
        contractor_endDate: "",
        // contractor_RoleId: "",
        contractor_RoleId: [],
        contractor_sliderImage: "",
      },
    };

  }

  openCreateForm = () => {
  this.setState({
    id: 0,
    BatchId: "",
    groupId: [],
    quarterPeriod: "",
    FromDate: null,
    endDate: null,
    sliderImage: "",
    AddMoreGift: [],
    AddMoreGiftContractor: [],
    IsEdit: false,
  });

  this.props.onHideShow(true);
};

  openContractorModal = (contractorNames) => {
    this.setState({ showContractorModal: true, selectedContractors: contractorNames });
  };

  closeContractorModal = () => {
    this.setState({ showContractorModal: false, selectedContractors: [] });
  };

  photoBodyTemplate = (rowData) => {
    if (rowData && rowData.summary && rowData.summary.FilePath) {
      return (
        <img
          src={rowData.summary.FilePath}
          alt={rowData.summary.CategoryName}
          style={{ width: '100px', height: 'auto', borderRadius: '4px' }}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = 'fallback-image-url.jpg'; // fallback image if broken link
          }}
        />
      );
    }
    return <span>No Image</span>;
  };

  groupNameBodyTemplate = (rowData) => {
    return (
      <a
        href="#!"
        onClick={(e) => {
          e.preventDefault();
          const expandedRows = { ...this.state.expandedRows };
          if (expandedRows[rowData.key]) {
            delete expandedRows[rowData.key];
          } else {
            expandedRows[rowData.key] = true;
          }
          this.setState({ expandedRows });
        }}
      >
        {rowData.summary.CategoryName}
      </a>
    );
  };

  rowExpansionTemplate = (data) => {
    // Safety check
    const details = data.details || [];

    // Extract and clean up all unique CategoryNames
    const uniqueCategoryNames = Array.from(
      new Set(details.map(item => item.CategoryName?.trim()).filter(Boolean))
    );

    return (
      <div style={{ padding: "1em", backgroundColor: "#f9f9f9" }}>
        <h5>Details for {data.summary?.CategoryName?.trim() || "N/A"}</h5>
        <p><strong>Group Names: </strong> {uniqueCategoryNames.join(", ") || "No Category Names Found"}</p>
        <p><strong>Start Date:</strong> {data.summary?.StartDate || "N/A"}</p>
        <p><strong>End Date:</strong> {data.summary?.EndDate || "N/A"}</p>
      </div>
    );
  };


  handleNext = () => {
    let isValid = this.validateAddBenefitForm();
    if (isValid) {
      this.setState({ activeIndex: 1 });
    }
  };

  handleNext2 = () => {
    
    const isValid = this.validateSpecialContractorBenefitForm(); // replace with your validation function

    if (isValid) {
      // ✅ Check and initialize tab-specific data before showing tab
      if (!this.state.AddMoreGiftContractor || this.state.AddMoreGiftContractor.length === 0) {
        this.setState({
          AddMoreGiftContractor: [{ key: "", value: "" }],
          activeIndex: 3 // Go to "Add Special Contractor Gift" tab
        });
      } else {
        this.setState({ activeIndex: 3 });
      }
    }
  };


  handleChange = (event) => {
    let name, value;

    if (event.value !== undefined) {
      // MultiSelect or Calendar
      name = event.target?.name;
      value = event.value;
    } else if (event.target) {
      name = event.target.name;
      value = event.target.value;
    }

    this.setState({ [name]: value }, () => {
      this.validateForm(value, name);
    });
  };
   handleQuarterChange = (e) => {
    const value = e.value;
    const year = new Date().getFullYear();
    let fromDate = null;
    let endDate = null;

    switch (value) {
      case "Q1":
        fromDate = new Date(year, 0, 1);   // 1 Jan
        endDate  = new Date(year, 2, 31);  // 31 Mar
        break;
      case "Q2":
        fromDate = new Date(year, 3, 1);   // 1 Apr
        endDate  = new Date(year, 5, 30);  // 30 Jun
        break;
      case "Q3":
        fromDate = new Date(year, 6, 1);   // 1 Jul
        endDate  = new Date(year, 8, 30);  // 30 Sep
        break;
      case "Q4":
        fromDate = new Date(year, 9, 1);   // 1 Oct
        endDate  = new Date(year, 11, 31); // 31 Dec
        break;
      case "ANNUALLY":
        fromDate = new Date(year, 0, 1);   // 1 Jan
        endDate  = new Date(year, 11, 31); // 31 Dec
        break;
        default:
        break;
    }

    this.setState({
      quarterPeriod: value,
      FromDate: fromDate,
      endDate: endDate,
      formError: {
        ...this.state.formError,
        quarterPeriod: "",
        FromDate: "",
        endDate: "",
      },
    });
  };

  deriveQuarterFromDate = (dateInput) => {
    if (!dateInput) return "";
    const month = new Date(dateInput).getMonth();
    if (isNaN(month)) return "";

    if (month <= 2) return "Q1";
    if (month <= 5) return "Q2";
    if (month <= 8) return "Q3";
    return "Q4";
  };

  validateAddBenefitForm = () => {
    let errors = { ...this.state.formError };
    let isValid = true;

    if (!this.state.groupId) {
      errors.groupId = "Please select a group";
      isValid = false;
    }

    if (!this.state.quarterPeriod) {
      errors.quarterPeriod = "Please select a quarter / period";
      isValid = false;
    }

    if (!this.state.sliderImage) {
      errors.sliderImage = "Please upload a banner image";
      isValid = false;
    }

    this.setState({ formError: errors });
    return isValid;
  };

  validateSpecialContractorBenefitForm = () => {

    let errors = { ...this.state.contractor_formError };
    let isValid = true;

    // Validate groupId selection
    if (!this.state.contractor_groupId || this.state.contractor_groupId === "0") {
      errors.contractor_groupId = "Please select a group";
      isValid = false;
    } else {
      errors.contractor_groupId = "";
    }

    // // Validate FromDate
    // if (!this.state.contractor_FromDate) {
    //   errors.contractor_FromDate = "Please select a start date";
    //   isValid = false;
    // } else {
    //   errors.contractor_FromDate = "";
    // }

    // // Validate endDate
    // if (!this.state.contractor_endDate) {
    //   errors.contractor_endDate = "Please select an end date";
    //   isValid = false;
    // } else {
    //   errors.contractor_endDate = "";
    // }

    // Validate date order (endDate > FromDate)
    if (this.state.contractor_FromDate && this.state.contractor_endDate) {
      const fromDate = new Date(this.state.contractor_FromDate);
      const endDate = new Date(this.state.contractor_endDate);
      if (endDate <= fromDate) {
        errors.contractor_endDate = "End date must be after start date";
        isValid = false;
      } else {
        // Clear previous error if any
        errors.contractor_endDate = "";
      }
    }

    // Validate sliderImage - must be non-empty string (URL or base64)
    if (!this.state.contractor_sliderImage || this.state.contractor_sliderImage.trim() === "") {
      errors.contractor_sliderImage = "Please upload a banner image";
      isValid = false;
    } else {
      errors.contractor_sliderImage = "";
    }

    // Update formError state with current errors
    this.setState({ contractor_formError: errors });

    return isValid;
  };


  uploadFiles(e) {
    e.preventDefault();
    //console.log(this.state.file)
  }
  getDropValueOfCategory() {
    let categoryName = "";
    this.props.CategoryDataList.filter((x) => {
      if (x.value === this.state.categoryId.toString()) {
        categoryName = x.label;
      }
    });

    return categoryName;
  }

  tblResponse = (response) => {
    if (response && response.ResponseCode === "200" && response.ResponseData) {
      const groupedData = this.groupDataByCategory(response.ResponseData);
      this.setState({ groupedCategoryData: groupedData });
    } else {
      this.setState({ groupedCategoryData: [] });
    }
  };
  
  componentDidMount() {
  const userData = JSON.parse(sessionStorage.getItem("UserData"));
  const AdminUserId = userData ? parseInt(userData, 10) : 0;
  this.setState({ AdminUserId });

  // ✅ Initialize the request object before any API call
  this.tblResponse = new tableRequest();
  this.tblResponse.UserId = userData?.UserId || 0; // if your request needs it

  const userPages = sessionStorage.getItem("assignedPermissionsForUser");
  if (userPages) {
    const assignedPermissions = JSON.parse(userPages);
    const Curenturl = window.location.pathname;
    const nNumber = Curenturl.lastIndexOf("/");
    const pageName = Curenturl.substring(nNumber + 1);

    const obj = assignedPermissions.assigned.filter(
      (x) => x.ActionName === pageName
    );
  
    if (obj !== null && obj.length > 0) {
      this.setState({
        IsEdit: obj[0].IsEdit,
        IsAdd: obj[0].IsAdd,
      });
    }
  }

  // ✅ Now tblResponse is ready, so fetchApi gets valid data
  this.props.fetchApi(this.tblResponse);

  this.props.getCategoryDDL();
  this.props.getContractorDDL();
  }

  tblResponse = (apiData) => {
    if (apiData && apiData.details) {
      this.setState({ details: apiData.details });
    }
  
    // Also update other state or handle other logic if needed
  };


  // Callback to process API response and group data by CategoryId
  tblResponse = (response) => {
    if (response && response.ResponseCode === "200" && response.ResponseData) {
      const groupedData = this.groupDataByCategory(response.ResponseData);
      this.setState({ groupedCategoryData: groupedData });
    } else {
      this.setState({ groupedCategoryData: [] });
    }
  };

  // Helper to group data by CategoryId
  groupDataByCategory = (data) => {
    const grouped = {};

    data.forEach(item => {
      const catId = item.CategoryId;
      if (!grouped[catId]) {
        grouped[catId] = {
          key: catId,
          summary: item, // summary info for the group row
          items: []
        };
      }
      grouped[catId].items.push(item);
    });

    return Object.values(grouped);
  };

  //category
  photoBodyTemplate(e) {
    if (e?.FilePath) {
      return (
        <a href={e.FilePath} target="_blank" rel="noopener noreferrer">
          <img
            src={e.FilePath}
            width="50px"
            alt="Image Preview"
            style={{ cursor: "pointer" }}
          />
        </a>
      );
    }
    return null;
  }


  photoBodyTemplateSubCate(e) {
    if (e.SubCateFilePath) {
      return <img src={e.SubCateFilePath} width="50px" />;
    }
  }

  //2409
  getContractorName = (rowData) => {
    const { UserRoleData } = this.state;
    const contractor = UserRoleData?.find(item => item.value === rowData.ContractorId);
    return contractor ? contractor.label : '-';
  };

  groupDataByCategory = (data) => {
    const grouped = {};

    data.forEach(item => {
      const catId = item.CategoryId;
      if (!grouped[catId]) {
        grouped[catId] = {
          key: catId,
          summary: item, // First item as summary
          items: []
        };
      }
      grouped[catId].items.push(item);
    });

    return Object.values(grouped);
  };


  componentDidUpdate(prevProps) {
  // 1️⃣ Update CategoryData
  if (prevProps.CategoryData !== this.props.CategoryData) {
    if (this.props.CategoryData && this.props.CategoryData.length > 0) {
      const groupedData = this.groupDataByBatch(this.props.CategoryData);

      this.setState({
        groupedCategoryData: groupedData,
        totalRecords: this.props.CategoryData[0]?.TotalRows || groupedData.length,
        expandedRows: null, // Reset expanded rows on new data
        first: 0, // Reset to first page after create/update
      });
    } else {
      this.setState({
        groupedCategoryData: [],
        totalRecords: 0,
        expandedRows: null,
        first: 0,
      });
    }
  }

  // 2️⃣ Update contractor dropdowns
  if (prevProps.contractDDL !== this.props.contractDDL) {
    const transformedRoles = this.props.contractDDL.map(item => ({
      label: item.DealerName,
      value: item.UserId
    }));

    const uniqueCities = [
      ...new Map(
        this.props.contractDDL.map(item => [item.CityName, { label: item.CityName, value: item.City }])
      ).values()
    ];

    this.setState({
      UserRoleData: transformedRoles,
      CityDropdownData: uniqueCities
    });
  }

  // 3️⃣ Update SubCategoryData if needed
  if (prevProps.SubCategoryData !== this.props.SubCategoryData) {
    if (this.props.SubCategoryData && this.props.SubCategoryData.length > 0) {
      this.setState({
        totalRecords2: this.props.SubCategoryData[0].TotalRows,
        first: 0,
      });
    } else {
      this.setState({
        totalRecords2: 0,
        first: 0,
      });
    }
  }
}

  async switchToggleConfirm() {
    const { switchAction, tblResponse } = this.state;
    const batchId = tblResponse?.summary?.BatchId || tblResponse?.BatchId;

    try {
      console.log("Switching status for Batch ID:", batchId);

      // Await the async Redux action (now fixed to return a Promise)
      const response = await this.props.inActiveRow(batchId, switchAction, tblResponse);

      // Optional: Check success inside the component
      if (response?.ResponseCode === "200") {
        console.log("Successfully updated status, refreshing data...");
        // The redux action already calls getAll(obj), so maybe you don't need to call fetchApi here
        //  await this.props.fetchApi(tblResponse); 
        window.location.reload();
      }

      // Close dialog
      this.setState({ showConfirmDialog: false });
    } catch (error) {
      console.error("Error toggling row status:", error);
    }

  }

  handleInactivate = (category, isActive, obj) => {
    this.setState({
      id: category,
      switchAction: isActive,
      tblResponse: obj,
      showConfirmDialog: true // example flag to show confirmation dialog
    });
  };

  switchHandleChange = (e) => {
    ;
    this.setState({
      switchAction: !rowData.IsActive,
      id: rowData.summary?.id || rowData.id,
      tblResponse: rowData, // Save the full row data here
    });
    this.props.onHideShowIsActive(true); // Show confirmation dialog
  };


  groupDataByBatch = (data) => {
    const grouped = {};

    // Ensure data is an array and filter out null/undefined items
    (data || []).forEach(item => {
      if (!item) return; // Skip invalid entries

      // Safely construct a key using BatchId or fallback composite key
      const key = item.BatchId || `${item.AddMoreGift || ''}_${item.StartDate || ''}_${item.EndDate || ''}_${item.FilePath || ''}`;

      if (!grouped[key]) {
        grouped[key] = {
          key,
          summary: item,
          details: [],
        };
      }

      grouped[key].details.push(item);
    });

    return Object.values(grouped);
  };

  handleChange = (event) => {
    let name;
    let value;

    // Handle MultiSelect & Calendar (PrimeReact components)
    if (event.value !== undefined) {
      name = event.target?.name || event.name;
      value = event.value;
    } else if (event.target) {
      // Normal input
      name = event.target.name;
      value = event.target.value;
    } else {
      return; // unknown event
    }

    this.setState({ [name]: value }, () => {
      this.validateForm(value, name);
    });
  };

  handleChange3 = (event) => {
    let name, value;

    if (event.target && event.target.name) {
      // For standard HTML inputs
      name = event.target.name;
      value = event.target.value;
    } else {
      // For PrimeReact Dropdown or similar
      // name = "contractor_RoleId";
      // value = event.value;
    }

    this.setState({ [name]: value }, () => {
      this.validateFormContractor(value, name);
    });
  };

  handleChange2 = (event) => {
    let name = event.target?.name || event.name;
    let value = event.target?.value ?? event.value;

    // Then handle different fields if needed
    if (name === "contractor_groupId") {
      this.setState({ [name]: value });
      return;
    }

    if (name === "contractor_FromDate" || name === "contractor_endDate") {
      this.setState({ [name]: value });
      return;
    }

    if (name === "contractor_RoleId") {
      const selectedContractor = this.props.contractDDL.find(
        (item) => item.UserId === value
      );
      const cityCode = selectedContractor?.City || null;

      this.setState({
        contractor_RoleId: value,
        selectedCity: cityCode,
      });
      return;
    }

    // Default fallback
    this.setState({ [name]: value });
  };

  handleCityChange = (e) => {
    this.setState({ selectedCity: e.value });
  };

  UpdatedDateTemplate(rowData) {
    formError;
    if (rowData.UpdatedDate !== null) {
      return <Moment format="D MMM YYYY">{rowData.UpdatedDate}</Moment>;
    }
  }

  CreatedDateTemplate(rowData) {
    if (rowData.UpdatedDate !== null) {
      return <Moment format="D MMM YYYY">{rowData.CreatedDate}</Moment>;
    }
  }

  validateForm = (value, key) => {
    let errors = this.state.formError;

    switch (key) {
      case "groupId":
        errors.groupId = !value || value.length === 0 ? "Please select Group name" : "";
        break;
      case "FromDate":
        errors.FromDate = !value ? "Please select From Date" : "";
        break;
      case "endDate":
        errors.endDate = !value ? "Please select End Date" : "";
        break;
      case "sliderImage":
        errors.sliderImage = !value ? "Please upload an image" : "";
        break;
      default:
        break;
    }

    this.setState({ formError: errors });
    return errors[key] === "";
  };

  isUniqueGiftList(addMoreGiftList) {
    const seen = new Set();
    return addMoreGiftList.every((gift) => {
      if (seen.has(gift.key)) {
        return false; // Duplicate key found
      }
      seen.add(gift.key);
      return true;
    });
  }

  isUniqueGiftListContractor(addMoreGiftListContractor) {
    const seen = new Set();
    return addMoreGiftListContractor.every((gift) => {
      if (seen.has(gift.key)) {
        return false; // Duplicate key found
      }
      seen.add(gift.key);
      return true;
    });
  }

  groupNameBodyTemplate = (rowData) => {
    return (
      <a
        href="#!"
        onClick={(e) => {
          e.preventDefault();
          const expandedRows = this.state.expandedRows || {};
          if (expandedRows[rowData.key]) {
            delete expandedRows[rowData.key];
          } else {
            expandedRows[rowData.key] = true;
          }
          this.setState({ expandedRows: { ...expandedRows } });
        }}
      >
        {rowData.summary.CategoryName}
      </a>
    );
  };

  refreshPage = async () => {
    // Step 1: Fetch latest data
    await this.props.fetchApi(this.tblResponse);

    // Step 2: Reset both forms
    this.resetForm();
    this.resetForm2();         // For form 1
    this.resetFormContractor(); // For form 2

    // Step 3: Clear any errors
    this.setState({ formError: {}, contractor_formError: {} });

    // Optional: scroll to top
    window.scrollTo({ top: 0, behavior: "smooth" });
  };


buildTableRequest = () => {
  const userData = JSON.parse(sessionStorage.getItem("UserData"));
  const userId = userData?.UserId || 0;

  const payload = {
    ...new tableRequest(),
    UserId: userId,
    PageNo: this.tblResponse?.PageNo || 1,
    First: this.tblResponse?.First || 1,
    PageSize: this.tblResponse?.PageSize || 5,
    SortColumn: this.tblResponse?.SortColumn || "CreatedDate",
    SortOrder: this.tblResponse?.SortOrder || "DESC",
    SearchValue: this.tblResponse?.SearchValue || "",
    StateId: this.tblResponse?.StateId || 0,
    CityId: this.tblResponse?.CityId || 0,
    ProductId: this.tblResponse?.ProductId || 0,
    FromDate: this.tblResponse?.FromDate || "",
    ToDate: this.tblResponse?.ToDate || "",
    IsActive: this.tblResponse?.IsActive ?? true,
  };

  console.log("✅ buildTableRequest payload:", payload);
  return payload; // ⚠️ Make sure you RETURN it!
};

// submitForm = async (event) => {
//   event.preventDefault();

  

//   /* -----------------------------
//      1️⃣ Validations
//   ----------------------------- */
  
//   if (!this.validateAddGiftForm()) return;

//   let isFormValid = true;
//   const formErrorCopy = { ...this.state.formError };
//   Object.keys(formErrorCopy).forEach((key) => {
//     if (!this.validateForm(this.state[key], key)) {
//       isFormValid = false;
//     }
//   });
//   if (!isFormValid) return;

//   if (!this.isUniqueGiftList(this.state.AddMoreGift)) {
//     alert("Duplicate Gift Name found in AddMoreGift.");
//     return;
//   }

//   /* -----------------------------
//      2️⃣ CREATE vs UPDATE (HARD RULE)
//   ----------------------------- */
//   const isUpdate = Number(this.state.id) > 0;

//   let batchId;

//   if (isUpdate) {
//     if (!this.state.BatchId) {
//       alert("Update failed: BatchId missing. Please reload and try again.");
//       return;
//     }
//     batchId = this.state.BatchId; // 🔑 MUST reuse
//   } else {
//     batchId = `${Date.now()}${Math.floor(Math.random() * 10000)}`;
//   }

//   /* -----------------------------
//      3️⃣ Prepare GroupIds
//   ----------------------------- */
//   const groupIds = Array.isArray(this.state.groupId)
//     ? this.state.groupId.map(Number)
//     : [Number(this.state.groupId)];

//   /* -----------------------------
//      4️⃣ Format Gifts
//   ----------------------------- */
//   const formattedGifts = JSON.stringify(
//     (this.state.AddMoreGift || []).map(g => ({ ...g, IsClaimed: 0 }))
//   );

//   const formattedContractorGifts = JSON.stringify(
//     (this.state.AddMoreGiftContractor || []).map(g => ({
//       key: g.key,
//       value: g.value,
//       IsClaimed: 0,
//     }))
//   );

//   /* -----------------------------
//      5️⃣ Payload (STRICT)
//   ----------------------------- */
//   const formData = {
//     id: isUpdate ? this.state.id : 0,
//     GroupId: groupIds,
//     createdby: this.state.AdminUserId,
//     StartDate: format(new Date(this.state.FromDate), "yyyy-MM-dd"),
//     EndDate: format(new Date(this.state.endDate), "yyyy-MM-dd"),
//     GiftImg: this.state.sliderImage || "",
//     AddMoreGift: formattedGifts,
//     BatchId: batchId, // 🔑 FINAL authority
//     ContractorRoleIds: (this.state.contractor_RoleId || []).map(Number),
//     SelectedCities: (this.state.selectedCity || []).map(Number),
//     AddMoreGiftContractor: formattedContractorGifts,
//   };

//   /* -----------------------------
//      6️⃣ Submit
//   ----------------------------- */
//   try {
//     console.log("🚀 SUBMIT FINAL", {
//       isUpdate,
//       id: formData.id,
//       BatchId: formData.BatchId,
//     });

//     if (isUpdate) {
//       await this.props.updateCategory(formData);
//     } else {
//       await this.props.createCategory(formData);
//     }

//     await new Promise(res => setTimeout(res, 300));
//     await this.props.fetchApi(this.buildTableRequest());

//     /* 🔑 reset ONLY AFTER successful submit */
//     this.resetForm();
//     this.props.onHideShow(false);

//   } catch (err) {
//     console.error(err);
//     alert("Submission failed.");
//   }
// };

//15/12

isGroupDateAlreadyExists = (groupIds, startDate, endDate) => {
  const rows = this.props.CategoryData || [];
  if (!Array.isArray(rows) || rows.length === 0) return false;

  const sDate = format(new Date(startDate), "yyyy-MM-dd");
  const eDate = format(new Date(endDate), "yyyy-MM-dd");

  return rows.some(row => {
    const rowGroupId = Number(row.CategoryId);
    const rowStart = format(new Date(row.StartDate), "yyyy-MM-dd");
    const rowEnd   = format(new Date(row.EndDate), "yyyy-MM-dd");

    return (
      groupIds.includes(rowGroupId) &&
      rowStart === sDate &&
      rowEnd === eDate
    );
  });
};

// getOverlappingGroups = (
//   groupIds,
//   startDate,
//   endDate,
//   excludeBatchId = null
// ) => {
//   const rows = this.props.CategoryData || [];
//   if (!rows.length) return [];

//   const today = new Date();
//   today.setHours(0, 0, 0, 0);

//   const newStart = new Date(startDate);
//   const newEnd = new Date(endDate);
//   newStart.setHours(0, 0, 0, 0);
//   newEnd.setHours(0, 0, 0, 0);

//   // 🔑 STEP 1: Keep ONLY latest active row per BatchId + Group
//   const latestMap = new Map();

//   rows.forEach(row => {
//     if (!row) return;

//     if (row.IsActive === false || row.IsActive === 0) return;

//     const rowEnd = new Date(row.EndDate);
//     rowEnd.setHours(0, 0, 0, 0);

//     // ❌ Ignore expired
//     if (rowEnd < today) return;

//     const key = `${row.CategoryId}_${row.BatchId}`;

//     const existing = latestMap.get(key);
//     if (!existing || new Date(existing.EndDate) < rowEnd) {
//       latestMap.set(key, row);
//     }
//   });

//   const filteredRows = Array.from(latestMap.values());

//   // 🔑 STEP 2: Check overlap only on filtered rows
//   const overlapping = [];

//   groupIds.forEach(groupId => {
//     const blocked = filteredRows.some(row => {
//       if (Number(row.CategoryId) !== Number(groupId)) return false;

//       if (
//         excludeBatchId &&
//         String(row.BatchId) === String(excludeBatchId)
//       ) return false;

//       const existStart = new Date(row.StartDate);
//       const existEnd = new Date(row.EndDate);
//       existStart.setHours(0, 0, 0, 0);
//       existEnd.setHours(0, 0, 0, 0);

//       return newStart <= existEnd && newEnd >= existStart;
//     });

//     if (blocked) overlapping.push(groupId);
//   });

//   return overlapping;
// };

getOverlappingGroups = (groupIds, fromDate, toDate, batchId) => {
  const newFrom = new Date(fromDate);
  const newTo = new Date(toDate);

  let overlapGroups = [];

  this.props.CategoryDataList.forEach(item => {
    // ❌ skip different groups
    if (!groupIds.includes(Number(item.value))) return;

    // ❌ skip same batch (update case)
    if (batchId && item.BatchId === batchId) return;

    const existingFrom = new Date(item.FromDate);
    const existingTo = new Date(item.EndDate);

    // ✅ overlap condition
    const isOverlap =
      newFrom <= existingTo &&
      newTo >= existingFrom;

    if (isOverlap) {
      overlapGroups.push(Number(item.value));
    }
  });

  return [...new Set(overlapGroups)];
};

// submitForm = async (event) => {
//   ;
//   event.preventDefault();

//   if (this.state.IsEdit && this.isExpiredBenefit()) {
//     toast.warning("Expired benefit dates cannot be modified.");
//     return;
//   }

//   /* -----------------------------
//      1️⃣ Basic Validations
//   ----------------------------- */
//   if (!this.validateAddGiftForm()) return;

//   let isFormValid = true;
//   const formErrorCopy = { ...this.state.formError };

//   Object.keys(formErrorCopy).forEach((key) => {
//     if (!this.validateForm(this.state[key], key)) {
//       isFormValid = false;
//     }
//   });

//   if (!isFormValid) return;

//   if (!this.isUniqueGiftList(this.state.AddMoreGift)) {
//     alert("Duplicate Gift Name found in AddMoreGift.");
//     return;
//   }

//   /* -----------------------------
//      2️⃣ CREATE vs UPDATE
//   ----------------------------- */
//   const isUpdate =
//   this.state.BatchId !== null &&
//   this.state.BatchId !== undefined &&
//   this.state.BatchId !== "";


//   let batchId;

//   if (isUpdate) {
//     if (!this.state.BatchId) {
//       alert("Update failed: BatchId missing. Please reload and try again.");
//       return;
//     }
//     batchId = this.state.BatchId;
//   } else {
//     batchId = `${Date.now()}${Math.floor(Math.random() * 10000)}`;
//   }

//   /* -----------------------------
//      3️⃣ Prepare GroupIds
//   ----------------------------- */
//   const groupIds = Array.isArray(this.state.groupId)
//     ? this.state.groupId.map(Number)
//     : [Number(this.state.groupId)];

// /* -----------------------------
//    🔴 CREATE ONLY VALIDATION
// ----------------------------- */
// if (!isUpdate) {
//   const exists = this.isGroupDateAlreadyExists(
//     groupIds,
//     this.state.FromDate,
//     this.state.endDate
//   );

//   if (exists) {
//     alert("GroupId already exist with StartDate and EndDate");
//     return; // ⛔ STOP CREATE
//   }
// }


//   /* -----------------------------
//      4️⃣ Format Gifts
//   ----------------------------- */
//   const formattedGifts = JSON.stringify(
//     (this.state.AddMoreGift || []).map((g) => ({
//       ...g,
//       IsClaimed: 0,
//     }))
//   );

//   const formattedContractorGifts = JSON.stringify(
//     (this.state.AddMoreGiftContractor || []).map((g) => ({
//       key: g.key,
//       value: g.value,
//       IsClaimed: 0,
//     }))
//   );

//   /* -----------------------------
//      5️⃣ Payload
//   ----------------------------- */
 
//   const formData = {
//   id: isUpdate ? this.state.id : 0,
//   GroupId: groupIds,
//   createdby: this.state.AdminUserId,
//   StartDate: format(new Date(this.state.FromDate), "yyyy-MM-dd"),
//   EndDate: format(new Date(this.state.endDate), "yyyy-MM-dd"),
//   GiftImg: this.state.sliderImage || "",
//   AddMoreGift: formattedGifts,
//   BatchId: batchId,
//   ContractorRoleIds: (this.state.contractor_RoleId || []).map(Number),

//   // ✅ FIXED HERE
//   SelectedCities: (this.state.selectedCity || []).map(v => {
//     const [cityId] = v.split("_");
//     return Number(cityId);
//   }),

//   AddMoreGiftContractor: formattedContractorGifts,
// };

//   /* -----------------------------
//      6️⃣ Submit
//   ----------------------------- */
//   try {
//     console.log("🚀 SUBMIT FINAL", {
//       isUpdate,
//       id: formData.id,
//       BatchId: formData.BatchId,
//     });

//     if (isUpdate) {
//       await this.props.updateCategory(formData);
//     } else {
//       await this.props.createCategory(formData);
//     }

//     await new Promise((res) => setTimeout(res, 300));
//     await this.props.fetchApi(this.buildTableRequest());

//     this.resetForm();
//     this.props.onHideShow(false);

//   } catch (err) {
//     console.error(err);
//     alert("Submission failed.");
//   }
// };


  // handleContractorChange = (e) => {
  //   const selectedContractorIds = e.value;

  //   // Get matching contractors from contractDDL
  //   const selectedContractors = this.props.contractDDL.filter(contractor =>
  //     selectedContractorIds.includes(contractor.UserId)
  //   );

  //   // Extract unique cities
  //   const allCities = [];
  //   const cityValuesSet = new Set();

  //   selectedContractors.forEach(contractor => {
  //     const cityValue = contractor.City;
  //     const cityLabel = contractor.CityName;

  //     // Only push if not already added
  //     if (!cityValuesSet.has(cityValue)) {
  //       allCities.push({
  //         label: cityLabel,
  //         value: cityValue
  //       });
  //       cityValuesSet.add(cityValue);
  //     }
  //   });

  //   const selectedCityValues = allCities.map(city => city.value); // or city object

  //   this.setState({
  //     contractor_RoleId: selectedContractorIds,
  //     CityDropdownData: allCities,
  //     selectedCity: selectedCityValues // ✅ Auto-select them
  //   });
  // };

  // 19/12

  submitForm = async (event) => {
  event.preventDefault();

  if (this.state.IsEdit && this.isExpiredBenefit()) {
    toast.warning("Expired benefit dates cannot be modified.");
    return;
  }

  /* -----------------------------
     1️⃣ Basic Validations
  ----------------------------- */
  if (!this.validateAddGiftForm()) return;

  let isFormValid = true;
  const formErrorCopy = { ...this.state.formError };

  Object.keys(formErrorCopy).forEach((key) => {
    if (!this.validateForm(this.state[key], key)) {
      isFormValid = false;
    }
  });

  if (!isFormValid) return;

  if (!this.isUniqueGiftList(this.state.AddMoreGift)) {
    alert("Duplicate Gift Name found in AddMoreGift.");
    return;
  }

  /* -----------------------------
     2️⃣ CREATE vs UPDATE
  ----------------------------- */
  const isUpdate =
    this.state.BatchId !== null &&
    this.state.BatchId !== undefined &&
    this.state.BatchId !== "";
  let batchId;

  if (isUpdate) {
    batchId = this.state.BatchId;
  } else {
    batchId = `${Date.now()}${Math.floor(Math.random() * 10000)}`;
  }

  /* -----------------------------
     3️⃣ Prepare GroupIds
  ----------------------------- */
  const groupIds = Array.isArray(this.state.groupId)
    ? this.state.groupId.map(Number)
    : [Number(this.state.groupId)];

  /* -----------------------------
     🔴 OVERLAP VALIDATION (CREATE + UPDATE)
  ----------------------------- */
 const isAnnualPeriod = this.state.quarterPeriod === "ANNUALLY";
 const overlapGroups = isAnnualPeriod
  ? [] // Skip overlap check for annual period
  : this.getOverlappingGroups(
      groupIds,
      this.state.FromDate,
      this.state.endDate,
      isUpdate ? this.state.BatchId : null
    );

 if (overlapGroups.length) {
  const groupNames = overlapGroups
    .map(id =>
      this.props.CategoryDataList.find(g => Number(g.value) === id)?.label ||
      `Group ${id}`
    )
    .join(", ");

  toast.error(
    `The following groups have active overlapping date ranges:\n${groupNames}\n\nPlease select a different date range.`
  );
  return;
}


  /* -----------------------------
     4️⃣ Format Gifts
  ----------------------------- */
  const formattedGifts = JSON.stringify(
    (this.state.AddMoreGift || []).map((g) => ({
      ...g,
      IsClaimed: 0,
    }))
  );
  
  const formattedContractorGifts = JSON.stringify(
    (this.state.AddMoreGiftContractor || []).map((g) => ({
      key: g.key,
      value: g.value,
      IsClaimed: 0,
    }))
  );

  /* -----------------------------
     5️⃣ Payload
  ----------------------------- */
  const formData = {
    
    id: isUpdate ? this.state.id : 0,
    GroupId: groupIds,
    createdby: this.state.AdminUserId,
    StartDate: format(new Date(this.state.FromDate), "yyyy-MM-dd"),
    EndDate: format(new Date(this.state.endDate), "yyyy-MM-dd"),
    GiftImg: this.state.sliderImage || "",
    AddMoreGift: formattedGifts,
    BatchId: batchId,
    QuarterWise: this.state.quarterPeriod || "",
    Quarter: this.state.quarterPeriod || "",
    ContractorRoleIds: (this.state.contractor_RoleId || []).map(Number),

    SelectedCities: (this.state.selectedCity || []).map(v => {
      const [cityId] = v.split("_");
      return Number(cityId);
    }),

    AddMoreGiftContractor: formattedContractorGifts,
  };

  /* -----------------------------
     6️⃣ Submit
  ----------------------------- */
  try {
    if (isUpdate) {
      await this.props.updateCategory(formData);
    } else {
      await this.props.createCategory(formData);
    }
     await this.props.fetchApi(this.buildTableRequest());
    //  setTimeout(() => this.refreshGroupedData(), 100);
     await new Promise((res) => setTimeout(res, 300));
     await this.props.fetchApi(this.buildTableRequest());
  
    this.resetForm();
    this.props.onHideShow(false);

  } catch (err) {
    console.error(err);
    alert("Submission failed.");
  }
};

  handleContractorChange = (e) => {
  const selectedContractorIds = e.value || [];

  const selectedContractors = this.props.contractDDL.filter(c =>
    selectedContractorIds.includes(c.UserId)
  );

  const allCities = [];
  const selectedCityValues = [];

  selectedContractors.forEach(contractor => {
    const cityId = contractor.City;        // string like "586"
    const cityName = contractor.CityName;  // "New Delhi"
    const contractorName = contractor.DealerName; // ✅ FIX

    const compositeValue = `${cityId}_${contractor.UserId}`;

    allCities.push({
      label: `${cityName} (${contractorName})`, // ✅ EXACT OUTPUT
      value: compositeValue,
      cityId,
      contractorId: contractor.UserId
    });

    selectedCityValues.push(compositeValue);
  });

  this.setState({
    contractor_RoleId: selectedContractorIds,
    CityDropdownData: allCities,
    selectedCity: selectedCityValues
  });
};

  getCitiesForContractors = (contractorIds) => {
  const allCities = [];

  contractorIds.forEach((id) => {
    const contractor = this.state.UserRoleData.find((c) => c.value === id);

    if (contractor && contractor.cities && Array.isArray(contractor.cities)) {
      contractor.cities.forEach((city) => {
        // Make city unique per contractor
        const cityKey = `${id}_${city.value}`;

        allCities.push({
          value: cityKey, // unique value
          label: `${city.label || city.CityName} (${contractor.label || contractor.DealerName})`,
          cityId: city.value,       // actual city ID
          contractorId: id,         // contractor ID
        });
      });
    }
  });

  return allCities;
};

  validateAddGiftForm = () => {
    let errors = { ...this.state.formError };
    let isValid = true;

    const isGiftEmpty = this.state.AddMoreGift.some(
      (gift) => !gift.key || !gift.value
    );
    if (isGiftEmpty) {
      errors.AddMoreGift = "Please fill in all gift details";
      isValid = false;
    }
    // this.setState({ formError: errors });
    return isValid;
  };

resetForm() {
  this.setState({
    /* 🔑 CRITICAL */
    id: 0,
    BatchId: "",

    groupId: [],
    quarterPeriod: "",
    FilePath: "",
    FromDate: "",
    endDate: "",
    IsActive: true,
    sliderImage: "",
    AddMoreGift: [],
    AddMoreGiftContractor: [],
    contractor_RoleId: [],
    selectedCity: [],

    IsEdit: false,

    formError: {
      groupId: "",
      FilePath: "",
      FromDate: "",
      endDate: "",
      IsActive: "",
      sliderImage: "",
      AddMoreGift: "",
    },
  });
}


  resetForm2 = () => {
    this.setState({
      id: 0,
      // contractor_groupId: "",
      contractor_groupId: [],
      contractor_FromDate: null,
      contractor_endDate: null,
      // contractor_RoleId: "",
      contractor_RoleId: [],
      selectedCity: [],
      contractor_sliderImage: "",
      contractor_shareurl: "",

      AddMoreGiftContractor: [
        {
          key: "",
          value: "",
          IsClaimed: 0,
        },
      ],
     
      contractor_formError: {},

      IsEdit: false,
      CreatedDate: null,
      UpdatedDate: null,
    });
  };


  getLazyLoadingValues(event) {
    this.setState({ rows: event.rows, first: event.first });
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
    //this.tblResponse.SortColumn = event.sortField;
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
  }
  //to lazy loadsubCate
  getLazyLoadingValuesSubCate(event) {
    this.setState({ rows2: event.rows, first2: event.first });
    this.tblResponse2.PageSize = event.rows;
    this.tblResponse2.First = event.first + 1;
    this.tblResponse2.IsActive = true;
    //this.tblResponse.SortColumn = event.sortField;
    this.tblResponse2.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
  }


  onPage(event) {
    this.props.loadingData(true);
    //imitate delay of a backend call 
    setTimeout(() => {
      this.getLazyLoadingValues(event);
      this.props.fetchApi(this.tblResponse);
    }, 250);
  }

  onPage2(event) {
    this.props.loadingData2(true);
    setTimeout(() => {
      this.getLazyLoadingValuesSubCate(event);
      this.props.SubCatefetchApi(this.tblResponse2);
    }, 250);
  }

  //to search
  searchFilter(e) {
    this.props.loadingData(true);
    this.tblResponse.SearchValue = e.target.value;
    this.props.fetchApi(this.tblResponse);
  }

  //to sort
  onSort(event) {
    this.props.loadingData(true);
    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField =
      event.multiSortMeta[0].field === "CreatedDate"
        ? "CreatedDate"
        : event.multiSortMeta[0].field;
    this.tblResponse.SortColumn = sortField ? sortField : "";
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC"; //this.state.sortOrder === 1 ? 'DESC' : 'ASC';
    this.props.fetchApi(this.tblResponse);
  }
  onSort2(event) {
    this.props.loadingData2(true);
    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField =
      event.multiSortMeta[0].field === "CreatedDate"
        ? "CreatedDate"
        : event.multiSortMeta[0].field;
    this.tblResponse2.SortColumn = sortField ? sortField : "";
    this.tblResponse2.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC"; //this.state.sortOrder === 1 ? 'DESC' : 'ASC';
    // this.props.SubCatefetchApi(this.tblResponse2);
  }

  onHide() {
    this.props.onHideShow(false);
    this.resetForm();
  }
  onHide2() {
    this.props.onHideShow2(false);
    this.resetForm2();
  }

 
  openDialog = () => {
    // Show the dialog
    this.props.onHideShow(true);

    // Reset the form
    this.resetForm();  // Reset the form
    this.resetForm2();

    // Reset form state (label, heading)
    this.setState({
      buttonLabel: "Submit",
      formHeading: "Add Extra Benefit",

      // Optionally reset pagination to first page
      first: 0,
      rows: 10, // or default page size
    }, () => {
      // Ensure tblResponse is in sync before fetching
      this.tblResponse.PageNo = 1;
      this.tblResponse.PageSize = this.state.rows;
      this.tblResponse.First = 1;
      this.tblResponse.SearchValue = "";
      this.tblResponse.SortOrder = "DESC"; // or default
      this.tblResponse.SortColumn = "CreatedDate"; // or default
      this.tblResponse.IsActive = true;

      // 🔄 Refresh only the data without full reload
      this.props.fetchApi(this.tblResponse);
    });
  };



  statusBodyTemplate(rowData) {
    if (rowData) {
      return (
        <Checkbox
          disabled
          checked={rowData.IsActive}
          color="primary"
          inputProps={{ "aria-label": "secondary checkbox" }}
        />
      );
    }
  }

  getCurrentDateMMDDYYY() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();

    today = mm + "/" + dd + "/" + yyyy;
    return today;
  }

  handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...this.state.AddMoreGift];
    list[index][name] = value;
    this.setState({ AddMoreGift: list });
  };

  handleInputChange2 = (e, index) => {
    const { name, value } = e.target;
    const list = [...this.state.AddMoreGiftContractor];
    if (name === "giftName") {
      list[index].key = value;       // mapping new input name to existing key property
    } else if (name === "giftValue") {
      list[index].value = value;     // mapping new input name to existing value property
    }
    this.setState({ AddMoreGiftContractor: list });
  };


  // handle click event of the Remove button
  handleRemoveClick = (index) => {
    const list = [...this.state.AddMoreGift];
    list.splice(index, 1);
    this.setState({ AddMoreGift: list });
  };

  handleRemoveClick2 = (index) => {
    const list = [...this.state.AddMoreGiftContractor];
    list.splice(index, 1);
    this.setState({ AddMoreGiftContractor: list });
  };

  // handle click event of the Add button
  handleAddClick = () => {
    this.setState({
      AddMoreGift: [
        ...this.state.AddMoreGift,
        { key: "", value: "", IsClaimed: 0 },
      ],
    });
  };

  handleAddClick2 = () => {
    this.setState({
      AddMoreGiftContractor: [
        ...this.state.AddMoreGiftContractor,
        { key: "", value: "", IsClaimed: 0 },
      ],
    });
  };


  actionBodyTemplate(rowData) {

    // Helper function to remove duplicates by key+value
    const mergeUniqueGifts = (arrays) => {
      const merged = [];
      const map = new Map();
      arrays.flat().forEach(item => {
        const mapKey = `${item.key}||${item.value}`; // unique identifier
        if (!map.has(mapKey)) {
          map.set(mapKey, true);
          merged.push(item);
        }
      });
      return merged;
    };

    // const editMode = () => {
    //   ;
    //   this.props.onHideShow(true);

    //   const details = rowData.details ?? [];

    //   // -----------------------------
    //   // Default state variables
    //   // -----------------------------
    //   let tab1_groupId = [];
    //   let tab1_GroupDropdownData = [];
    //   let tab1_FromDate = null;
    //   let tab1_endDate = null;
    //   let tab1_sliderImage = "";
    //   let tab2_AddMoreGift = [];

    //   let tab3_contractor_groupId = [];
    //   let tab3_contractor_FromDate = null;
    //   let tab3_contractor_endDate = null;
    //   let tab3_contractor_sliderImage = "";
    //   let tab3_contractor_RoleId = [];
    //   let tab3_selectedCity = [];
    //   let tab3_CityDropdownData = [];
    //   let tab4_AddMoreGiftContractor = [];

    //   const batchId = rowData.BatchId || rowData.summary?.BatchId || details[0]?.BatchId;

    //   let activeIndex = 0;
    //   let formHeading = "Update Extra Benefit";
    //   let buttonLabel = "Update";

    //   // -----------------------------
    //   // Populate Tab 1 & 2 (Regular Benefit)
    //   // -----------------------------
    //   const batchRows = this.props.CategoryData.filter(
    //     item => String(item.BatchId || "").trim() === String(batchId || "").trim()
    //   );

    //   if (batchRows.length) {
    //     const baseRow = batchRows[0];

    //     // --- Tab 1 Groups for MultiSelect ---
    //     const allGroups = this.props.CategoryDataList || []; // All available groups

    //     // Selected IDs from batchRows
    //     tab1_groupId = batchRows.map(r => Number(r.CategoryId)).filter(Boolean);

    //     // Filter selected IDs to those present in allGroups
    //     tab1_groupId = tab1_groupId.filter(id => allGroups.some(g => Number(g.value) === id));

    //     // Dropdown options for MultiSelect
    //     tab1_GroupDropdownData = allGroups.map(g => ({
    //       value: Number(g.value),
    //       label: g.label || `Group ${g.value}`,
    //     }));

    //     tab1_FromDate = baseRow.StartDate ? new Date(baseRow.StartDate) : null;
    //     tab1_endDate = baseRow.EndDate ? new Date(baseRow.EndDate) : null;
    //     tab1_sliderImage = baseRow.FilePath || "";

    //     // Gifts – merge and deduplicate
    //     const allGifts = batchRows.flatMap(r => {
    //       if (r.AddMoreGift && r.AddMoreGift !== "True") {
    //         try {
    //           return JSON.parse(r.AddMoreGift).map(item => ({
    //             ...item,
    //             IsClaimed: 0,
    //           }));
    //         } catch {
    //           return [];
    //         }
    //       }
    //       return [];
    //     });

    //     tab2_AddMoreGift = [
    //       ...new Map(allGifts.map(item => [item.key + "|" + item.value, item])).values(),
    //     ];
    //   }

    //   // -----------------------------
    //   // Populate Tab 3 & 4 (Contractor Benefit)
    //   // -----------------------------
    //   if (details.length) {
    //     const baseRow = details[0];

    //     tab3_contractor_groupId = details.map(d => d.CategoryId).filter(Boolean).map(Number);
    //     tab3_contractor_FromDate = baseRow.StartDate ? new Date(baseRow.StartDate) : null;
    //     tab3_contractor_endDate = baseRow.EndDate ? new Date(baseRow.EndDate) : null;
    //     tab3_contractor_sliderImage = baseRow.FilePath || "";

    //     // Contractor + City values
    //     tab3_contractor_RoleId = baseRow.ContractorId
    //       ? baseRow.ContractorId.split(",").map(id => Number(id.trim()))
        
    //       : [];
    //     tab3_selectedCity = baseRow.City
    //       ? baseRow.City.split(",").map(id => Number(id.trim()))
    //       : [];

    //     // --- Build City Dropdown from contractDDL ---
    //     const allCities = this.props.contractDDL?.map(c => ({
    //       value: Number(c.City),
    //       label: c.CityName || `City ${c.City}`,
    //     })) || [];

    //     // Filter selected cities that exist in allCities
    //     tab3_selectedCity = tab3_selectedCity.filter(id => allCities.some(c => c.value === id));

    //     tab3_CityDropdownData = allCities;

    //     // -----------------------------
    //     // Gifts (Contractor tab)
    //     // -----------------------------
    //     const allContractorGifts = details.flatMap(r => {
    //       if (r.AddMoreGiftContr && r.AddMoreGiftContr !== "True") {
    //         try {
    //           return JSON.parse(r.AddMoreGiftContr).map(item => ({
    //             ...item,
    //             IsClaimed: 0,
    //           }));
    //         } catch {
    //           return [];
    //         }
    //       }
    //       return [];
    //     });

    //     tab4_AddMoreGiftContractor = [
    //       ...new Map(allContractorGifts.map(item => [item.key + "|" + item.value, item])).values(),
    //     ];
    //   }

    //   // -----------------------------
    //   // Update State
    //   // -----------------------------
    //   this.setState({
    //     formHeading,
    //     buttonLabel,
    //     IsEdit: true,

    //     // Tab 1
    //     id: rowData.id,
    //     groupId: tab1_groupId,
    //     tab1_GroupDropdownData, // MultiSelect options
    //     FromDate: tab1_FromDate,
    //     endDate: tab1_endDate,
    //     sliderImage: tab1_sliderImage,

    //     // Tab 2
    //     AddMoreGift: tab2_AddMoreGift,

    //     // Tab 3
    //     contractor_groupId: tab3_contractor_groupId,
    //     contractor_FromDate: tab3_contractor_FromDate,
    //     contractor_endDate: tab3_contractor_endDate,
    //     contractor_sliderImage: tab3_contractor_sliderImage,
    //     contractor_RoleId: tab3_contractor_RoleId,
    //     selectedCity: tab3_selectedCity,
    //     CityDropdownData: tab3_CityDropdownData,

    //     // Tab 4
    //     AddMoreGiftContractor: tab4_AddMoreGiftContractor,

    //     BatchId: batchId,
    //     activeIndex,
    //   });
    // };
   //2212
const editMode = () => {
  this.props.onHideShow(true);

  const details = rowData.details ?? [];

  /* --------------------------------
     Default variables
  -------------------------------- */
  let tab1_groupId = [];
  let tab1_GroupDropdownData = [];
  let tab1_FromDate = null;
  let tab1_endDate = null;
  let tab1_sliderImage = "";
  let tab2_AddMoreGift = [];
  let baseRowTab1 = null;

  let tab3_contractor_groupId = [];
  let tab3_contractor_FromDate = null;
  let tab3_contractor_endDate = null;
  let tab3_contractor_sliderImage = "";
  let tab3_contractor_RoleId = [];
  let tab3_selectedCity = [];
  let tab3_CityDropdownData = [];
  let tab4_AddMoreGiftContractor = [];
  
  const batchId =
    rowData.BatchId ||
    rowData.summary?.BatchId ||
    details[0]?.BatchId;

  let activeIndex = 0;
  let formHeading = "Update Extra Benefit";
  let buttonLabel = "Update";

  /* --------------------------------
     TAB 1 & 2 – Regular Benefit
  -------------------------------- */
  const batchRows = this.props.CategoryData.filter(
    item =>
      String(item.BatchId || "").trim() ===
      String(batchId || "").trim()
  );

  if (batchRows.length) {
    baseRowTab1 = batchRows[0];

    const allGroups = this.props.CategoryDataList || [];

    tab1_groupId = batchRows
      .map(r => Number(r.CategoryId))
      .filter(Boolean)
      .filter(id => allGroups.some(g => Number(g.value) === id));

    tab1_GroupDropdownData = allGroups.map(g => ({
      value: Number(g.value),
      label: g.label || `Group ${g.value}`,
    }));

    tab1_FromDate = baseRowTab1.StartDate
      ? new Date(baseRowTab1.StartDate)
      : null;
    tab1_endDate = baseRowTab1.EndDate
      ? new Date(baseRowTab1.EndDate)
      : null;
    tab1_sliderImage = baseRowTab1.FilePath || "";

    const allGifts = batchRows.flatMap(r => {
      if (r.AddMoreGift && r.AddMoreGift !== "True") {
        try {
          return JSON.parse(r.AddMoreGift).map(item => ({
            ...item,
            IsClaimed: 0,
          }));
        } catch {
          return [];
        }
      }
      return [];
    });

    tab2_AddMoreGift = [
      ...new Map(
        allGifts.map(item => [item.key + "|" + item.value, item])
      ).values(),
    ];
  }

  /* --------------------------------
     TAB 3 & 4 – Contractor Benefit
  -------------------------------- */
  if (details.length) {
    const baseRow = details[0];

    tab3_contractor_groupId = details
      .map(d => d.CategoryId)
      .filter(Boolean)
      .map(Number);

    tab3_contractor_FromDate = baseRow.StartDate
      ? new Date(baseRow.StartDate)
      : null;

    tab3_contractor_endDate = baseRow.EndDate
      ? new Date(baseRow.EndDate)
      : null;

    tab3_contractor_sliderImage = baseRow.FilePath || "";

    /* --------------------------------
       ✅ CONTRACTOR + CITY (EDIT MODE)
       SAME SHAPE AS CREATE MODE
    -------------------------------- */

    const contractorIds = baseRow.ContractorId
      ? baseRow.ContractorId.split(",").map(id => Number(id.trim()))
      : [];

    // ✅ AUTO-SELECT CONTRACTORS
    tab3_contractor_RoleId = contractorIds;

    const editCityOptions = [];
    const editSelectedCities = [];

    contractorIds.forEach(contractorId => {
      const contractor = this.props.contractDDL.find(
        c => c.UserId === contractorId
      );

      if (!contractor) return;

      const cityId = contractor.City;
      const cityName = contractor.CityName;
      const contractorName = contractor.DealerName;

      const compositeValue = `${cityId}_${contractorId}`;

      editCityOptions.push({
        value: compositeValue,
        label: `${cityName} (${contractorName})`,
        cityId,
        contractorId,
      });

      editSelectedCities.push(compositeValue);
    });

    tab3_selectedCity = editSelectedCities;
    tab3_CityDropdownData = editCityOptions;

    /* --------------------------------
       Contractor Gifts
    -------------------------------- */
    const allContractorGifts = details.flatMap(r => {
      if (r.AddMoreGiftContr && r.AddMoreGiftContr !== "True") {
        try {
          return JSON.parse(r.AddMoreGiftContr).map(item => ({
            ...item,
            IsClaimed: 0,
          }));
        } catch {
          return [];
        }
      }
      return [];
    });

    tab4_AddMoreGiftContractor = [
      ...new Map(
        allContractorGifts.map(
          item => [item.key + "|" + item.value, item]
        )
      ).values(),
    ];
  }

  const derivedQuarterPeriod =
    (baseRowTab1 && (baseRowTab1.QuarterWise || baseRowTab1.Quarter)) ||
    this.deriveQuarterFromDate(tab1_FromDate);

  /* --------------------------------
     SET STATE (FINAL)
  -------------------------------- */
  this.setState({
    formHeading,
    buttonLabel,
    IsEdit: true,

    // Tab 1
    id: rowData.id,
    groupId: tab1_groupId,
    tab1_GroupDropdownData,
    quarterPeriod: derivedQuarterPeriod,
    FromDate: tab1_FromDate,
    endDate: tab1_endDate,
    sliderImage: tab1_sliderImage,

    // Tab 2
    AddMoreGift: tab2_AddMoreGift,

    // Tab 3
    contractor_groupId: tab3_contractor_groupId,
    contractor_FromDate: tab3_contractor_FromDate,
    contractor_endDate: tab3_contractor_endDate,
    contractor_sliderImage: tab3_contractor_sliderImage,
    contractor_RoleId: tab3_contractor_RoleId,
    selectedCity: tab3_selectedCity,
    CityDropdownData: tab3_CityDropdownData,

    // Tab 4
    AddMoreGiftContractor: tab4_AddMoreGiftContractor,

    BatchId: batchId,
    activeIndex,
  });
};


    const switchHandleChange = () => {
      const isActive = rowData?.summary?.IsActive ?? rowData?.IsActive ?? false;
      this.setState({
        switchAction: !isActive,
        id: rowData?.summary?.id || rowData?.id,
        tblResponse: rowData,
      });
      this.props.onHideShowIsActive(true);
    };

    const isChecked = rowData?.summary?.IsActive ?? rowData?.IsActive ?? false;

    return (
      <div className="p-d-flex p-ai-center">
        <Switch
          checked={isChecked}
          color="primary"
          onChange={switchHandleChange}
          inputProps={{ "aria-label": "Toggle Status" }}
        />
        <Button
          icon="pi pi-pencil"
          onClick={editMode}
        />
      </div>
    );
  }

  setImagePath(event) {
    let errors = this.state.formError;
    errors.sliderImage = "";
    //errors.promotionalImage="";
    if (event.xhr) {
      if (event.xhr.response) {
        const response = JSON.parse(event.xhr.response);
        if (response) {
          if (response.ResponseCode === "200") {
            this.setState({
              sliderImage: response.Source,
              //promotionalImage: response.Source
            });
          } else if (response.ResponseCode === "400") {
            errors.sliderImage = "Only image format is accepted.";
            this.setState({
              sliderImage: [],
              //promotionalImage:[],
            });
          } else {
            // this.messageService.add({ severity: 'error', summary: 'Oops', detail: response.ResponseMessage });
          }
        } else {
          //this.messageService.add({ severity: 'error', summary: 'Oops', detail: 'Something went wrong' });
        }
      } else {
        //this.messageService.add({ severity: 'error', summary: 'Oops', detail: 'Something went wrong' });
      }
    } else {
      //this.messageService.add({ severity: 'error', summary: 'Oops', detail: 'Something went wrong' });
    }
  }

  // set Category Image Path
  setSubCateImagePath(event) {
    let errors = this.state.formError;
    errors.SubCateImage = "";
    //errors.promotionalImage="";
    if (event.xhr) {
      if (event.xhr.response) {
        const response = JSON.parse(event.xhr.response);
        if (response) {
          if (response.ResponseCode === "200") {
            this.setState({
              SubCateImage: response.Source,
              //promotionalImage: response.Source
            });
          } else if (response.ResponseCode === "400") {
            errors.SubCateImage = "Only image format is accepted.";
            this.setState({
              SubCateImage: [],
              //promotionalImage:[],
            });
          } else {
            // this.messageService.add({ severity: 'error', summary: 'Oops', detail: response.ResponseMessage });
          }
        } else {
          //this.messageService.add({ severity: 'error', summary: 'Oops', detail: 'Something went wrong' });
        }
      } else {
        //this.messageService.add({ severity: 'error', summary: 'Oops', detail: 'Something went wrong' });
      }
    } else {
      //this.messageService.add({ severity: 'error', summary: 'Oops', detail: 'Something went wrong' });
    }
  }

  // set Category Image Path
  setImagePathContractor(event) {
    let errors = this.state.contractor_formError;
    errors.contractor_sliderImage = "";
    //errors.promotionalImage="";
    if (event.xhr) {
      if (event.xhr.response) {
        const response = JSON.parse(event.xhr.response);
        if (response) {
          if (response.ResponseCode === "200") {
            this.setState({
              contractor_sliderImage: response.Source,
              //promotionalImage: response.Source
            });
          } else if (response.ResponseCode === "400") {
            errors.contractor_sliderImage = "Only image format is accepted.";
            this.setState({
              contractor_sliderImage: [],
              //promotionalImage:[],
            });
          } else {
            // this.messageService.add({ severity: 'error', summary: 'Oops', detail: response.ResponseMessage });
          }
        } else {
          //this.messageService.add({ severity: 'error', summary: 'Oops', detail: 'Something went wrong' });
        }
      } else {
        //this.messageService.add({ severity: 'error', summary: 'Oops', detail: 'Something went wrong' });
      }
    } else {
      //this.messageService.add({ severity: 'error', summary: 'Oops', detail: 'Something went wrong' });
    }
  }

  // set Category Image Path
  setSubCateImagePathContractor(event) {
    let errors = this.state.contractor_formError;
    errors.SubCateImageContractor = "";
    //errors.promotionalImage="";
    if (event.xhr) {
      if (event.xhr.response) {
        const response = JSON.parse(event.xhr.response);
        if (response) {
          if (response.ResponseCode === "200") {
            this.setState({
              SubCateImageContractor: response.Source,
              //promotionalImage: response.Source
            });
          } else if (response.ResponseCode === "400") {
            errors.SubCateImageContractor = "Only image format is accepted.";
            this.setState({
              SubCateImageContractor: [],
              //promotionalImage:[],
            });
          } else {
            // this.messageService.add({ severity: 'error', summary: 'Oops', detail: response.ResponseMessage });
          }
        } else {
          //this.messageService.add({ severity: 'error', summary: 'Oops', detail: 'Something went wrong' });
        }
      } else {
        //this.messageService.add({ severity: 'error', summary: 'Oops', detail: 'Something went wrong' });
      }
    } else {
      //this.messageService.add({ severity: 'error', summary: 'Oops', detail: 'Something went wrong' });
    }
  }

  isExpiredBenefit = () => {
  const { endDate } = this.state;

  if (!endDate) return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const eDate = new Date(endDate);
  eDate.setHours(0, 0, 0, 0);

  return eDate < today;
};

  render() {
    const isExpired = this.isExpiredBenefit();

    const renderFooter = (name) => {
      return (
        <div>
          <Button
            label="No"
            icon="pi pi-times"
            onClick={() => this.props.onHideShowIsActive(false)}
            className="p-button-text"
          />
          <Button
            label="Yes"
            icon="pi pi-check"
            onClick={this.switchToggleConfirm}
            autoFocus
          />
        </div>
      );
    };

    const header = (
      <div className="table-header row ">
        <div className="col-md-6 master_headhingcol">
          <h4 className="user">Extra Benefit</h4>
        </div>
        <div className="col-md-6 text-right">
          <span className="p-input-icon-left mr-2">
            <i className="pi pi-search" />
            <InputText
              type="search"
              onInput={(e) => this.searchFilter(e)}
              placeholder="Global Search"
            />
          </span>

          {this.state.IsAdd === true ? (
            <Button
              className="mr-2"
              label="Add Extra Benefit"
              icon="pi pi-plus-circle"
              onClick={this.openDialog}
            />
          ) : (
            <Button
              className="mr-2"
              label="Add category"
              icon="pi pi-plus-circle"
              style={{ display: "none" }}
              onClick={this.openDialog}
            />
          )}
        </div>
      </div>
    );

    // Template for "Add Gift to this Group"
    
    return (
      
      <div className="datatable-filter-demo dash-margin">
        <ToastContainer />

        <div className="card">
          <DataTable
            value={this.state.groupedCategoryData}
          
            expandedRows={this.state.expandedRows}
            onRowToggle={(e) => this.setState({ expandedRows: e.data })}
            dataKey="key"
            scrollable
            responsive={true}
            globalFilter={this.state.globalFilter}
            header={header}
            emptyMessage="No data found."
            sortMode="multiple"
            paginator={true}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={this.state.rows}
            style={{ width: "100%" }}
            rowsPerPageOptions={[10, 20, 30, 50, 100]}
            totalRecords={parseInt(this.state.totalRecords)}
            lazy={true}
            first={this.state.first}
            onPage={this.onPage}
            onSort={this.onSort}
            loading={this.props.loading}
            ref={(el) => {
              this.dt = el;
            }}
            rowExpansionTemplate={this.rowExpansionTemplate}
          >
            {/* Expander column for toggle */}
            <Column expander style={{ width: "3em" }} />

            {/* Group Name with clickable hyperlink */}
            <Column
              style={{ width: "40%" }}
              field="summary.CategoryName"
              header="Group Name"
              body={this.groupNameBodyTemplate}
              sortable
            />

            <Column
              style={{ width: "40%" }}
              field="summary.FilePath"
              header="Banner Image"
              body={this.photoBodyTemplate}
              sortable
            />

            <Column
              style={{ width: "40%" }}
              field="summary.StartDate"
              header="Start Date"
              sortable
            />

            <Column
              style={{ width: "40%" }}
              field="summary.EndDate"
              header="End Date"
              sortable
            />


            
            <Column
  header="Contractor"
  style={{ width: "40%" }}
  body={(rowData) => {
    const details = rowData.details || [];
    if (!details.length || !details[0]?.ContractorId) {
      return "All Contractor";
    }

    // Build contractor → gift mapping
    const contractorGiftMap = [];

    details.forEach((d) => {
      const contractorIds = d.ContractorId
        ? d.ContractorId.split(",").map((id) => id.trim())
        : [];

      contractorIds.forEach((id) => {
        const contractor = this.state.UserRoleData.find(
          (c) => c.value?.toString() === id
        );
        const name = contractor ? contractor.label : `Contractor ${id}`;

        // Parse AddMoreGiftContr JSON
        let gifts = [];
        if (d.AddMoreGiftContr && d.AddMoreGiftContr !== "True") {
          try {
            gifts = JSON.parse(d.AddMoreGiftContr);
          } catch {
            gifts = [];
          }
        }

        contractorGiftMap.push({ id, name, gifts });
      });
    });

    // Remove duplicates by contractor id
    const uniqueContractors = Array.from(
      new Map(contractorGiftMap.map((c) => [c.id, c])).values()
    );

    if (!uniqueContractors.length) return "No Contractors";
    if (uniqueContractors.length === 1)
      return (
        <span>
          {uniqueContractors[0].name}
          {uniqueContractors[0].gifts.length ? (
            <span style={{ color: "#777", fontSize: "12px" }}>
              {" "}
              ({uniqueContractors[0].gifts.length} Gifts)
            </span>
          ) : null}
        </span>
      );

    // Multiple contractors → open modal
    return (
      <a
        href="#!"
        onClick={(e) => {
          e.preventDefault();
          this.openContractorModal(uniqueContractors);
        }}
      >
        {`${uniqueContractors.length} Contractors`}
      </a>
    );
  }}
/>


            <Column
              field="Action"
              header="Action"
              style={{ width: "20%" }}
              body={this.actionBodyTemplate}
            />

          </DataTable>
        </div>


        <Dialog
          header={this.state.formHeading}
          modal
          dismissableMask={false}
          visible={this.props.showDialog}
          className="popup"
          onHide={this.onHide}
        >
          <TabView
            activeIndex={this.state.activeIndex}
            onTabChange={(e) => this.setState({ activeIndex: e.index })}
          >
            <TabPanel header="Add Benefit">
              <form onSubmit={this.submitForm} autocomplete="off">
                <div className="row">


                  <div className="col-md-4 pt-2">
                    <MultiSelect
                      name="groupId"
                      value={this.state.groupId} // array of values
                      options={this.state.tab1_GroupDropdownData || this.props.CategoryDataList}
                      optionLabel="label"
                      optionValue="value"
                      onChange={this.handleChange}
                      filter
                      placeholder="Select Groups"
                      display="chip"
                      className="form-control custom-select"
                      appendTo={document.body}
                    />

                    {this.state.formError.groupId !== "" ? (
                      <div className="error">
                        {this.state.formError.groupId}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  {/* Quarter / Period Dropdown */}
                  <div className="col-md-4 pt-2">
                    <Dropdown
                      name="quarterPeriod"
                      value={this.state.quarterPeriod}
                      options={[
                        { label: "Q 1 (Jan - Mar)", value: "Q1" },
                        { label: "Q 2 (Apr - Jun)", value: "Q2" },
                        { label: "Q 3 (Jul - Sep)", value: "Q3" },
                        { label: "Q 4 (Oct - Dec)", value: "Q4" },
                        { label: "Annually (Jan - Dec)",  value: "ANNUALLY" },
                      ]}
                      onChange={this.handleQuarterChange}
                      placeholder="Select Quarter / Period"
                      className="form-control"
                      appendTo={document.body}
                    />
                    {this.state.formError.quarterPeriod ? (
                      <div className="error">{this.state.formError.quarterPeriod}</div>
                    ) : ""}
                  </div>

                  {/* From Date & End Date are hidden — auto-set by Quarter selection */}
                  <br></br>
                  <br></br> <br></br>
                  <div class="fileslider col-md-4 col-xl-4">
                    {/* <span>Upload Banner Image</span> */}
                    <FileUpload
                      name="sliderImage"
                      mode="basic"
                      url={
                        process.env.REACT_APP_API_URL + "UploadFile/ImageUpload"
                      }
                      auto={true}
                      onUpload={this.setImagePath}
                      onChange={this.fileSelectedHandler}
                      onError={this.onErrorImage}
                      accept="image/*"
                    />
                    {/* <button type="button" className="btn btn-warning btn-block" onClick={this.submitForm}>Upload</button> */}
                  </div>
                  <div className="fileslider col-md-2 col-xl-4">
                    {this.state.IsEdit === true ? (
                      <Button label="Next"
                        icon="pi pi-arrow-right"
                        onClick={this.handleNext} />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="fileslider col-md-8 col-xl-8">
                    <TextField
                      disabled
                      hidden
                      id="standard-basic"
                      size="small"
                      onChange={this.handleChange}
                      value={this.state.sliderImage}
                      name="shareurl"
                      variant="outlined"
                      className="width"
                      label="File Url : "
                    />
                    <div className="blockimgprive">
                      {this.state.sliderImage ? (
                        <div className="p-fileupload-content mt-3 p-1">
                          <div>
                            <img
                              alt=" "
                              role="presentation"
                              src={this.state.sliderImage}
                              width="150"
                              height="100"
                            />
                          </div>
                        </div>
                      ) : null}
                    
                      {this.state.formError.sliderImage !== null ? (
                        <div className="error">
                          {this.state.formError.sliderImage}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </form>
            </TabPanel>
           
            <TabPanel header="Add Gift">
              <div style={{ overflowX: 'hidden', width: '100%' }}>
                <div className="col-md-12 text-right">
                  <Button
                    onClick={this.handleAddClick}
                    label="Add"
                    icon="pi pi-plus"
                  />
                </div>

               
                {this.state.AddMoreGift.map((x, i) => {
                  return (
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Gift Name:</label>
                          <input
                            name="key"
                            className="form-control"
                            placeholder="Enter Gift Name"
                            value={x.key}
                            onChange={(e) => this.handleInputChange(e, i)}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Value:</label>
                          <input
                            className="form-control"
                            name="value"
                            placeholder="Enter Value"
                            value={x.value}
                            onChange={(e) => this.handleInputChange(e, i)}
                          />
                        </div>
                      </div>
                      <div className="col-md-2 pt-4">
                        {this.state.AddMoreGift.length !== 1 && (
                          <Button
                            icon="pi pi-times"
                            onClick={() => this.handleRemoveClick(i)}
                            className="p-button-rounded p-button-danger p-button-text"
                          />
                        )}
                      </div>
                    </div>
                  );
                })}
                {/* <div className="col-md-12 text-center">
                  <Button label="Submit" icon="pi pi-check" onClick={this.submitForm} />
                </div> */}
              </div>

            </TabPanel>

            {/* //Add Contractor Wise  */}

            <TabPanel header="Add Benefit Special Contractor">
              <form onSubmit={this.submitForm2} autoComplete="off">


                {/* Contractor Role Dropdown */}
                <div className="row pt-3">

                  {/* Dropdown 1: Scheme Beneficiary */}
                  <div className="col-md-4">
                    <div className="form-group">


                      <MultiSelect
                        name="contractor_RoleId"
                        value={this.state.contractor_RoleId}
                        onChange={this.handleContractorChange}
                        options={this.state.UserRoleData}
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Scheme Beneficiaries*"
                        display="chip"
                        className="form-control"
                        filter
                        appendTo={document.getElementById("root")}
                      />


                      {this.state.contractor_formError?.contractor_RoleId && (
                        <div className="error">{this.state.contractor_formError.contractor_RoleId}</div>
                      )}


                    </div>
                  </div>

                  
                  {/* Dropdown 2: City */}
                  {/* <MultiSelect
                    name="selectedCity"
                    value={this.state.selectedCity}           // IDs array
                    options={this.state.CityDropdownData}     // All cities with labels
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Select Cities"
                    display="chip"
                    className="form-control"
                    filter
                    appendTo={document.getElementById("root")}
                  /> */}

                  {/* 19/12 */}
             <MultiSelect
  name="selectedCity"
  value={this.state.selectedCity || []}
  options={this.state.CityDropdownData || []}
  optionLabel="label"
  optionValue="value"
  display="chip"
  className="form-control"
  filter
  appendTo={document.getElementById("root")}
/>


                </div>


              </form>
            </TabPanel>


            <TabPanel header="Add Gift Special Contractor">
              <div style={{ overflowX: 'hidden', width: '100%' }}>
                <div className="col-md-12 text-right">
                  <Button
                    onClick={this.handleAddClick2}
                    label="Add"
                    icon="pi pi-plus"
                  />
                </div>

                {this.state.AddMoreGiftContractor.map((x, i) => {
                  return (
                    <div className="row" key={i}>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Gift Name:</label>
                          <input
                            name="giftName"   // changed from "key"
                            className="form-control"
                            placeholder="Enter Gift Name"
                            value={x.key}     // still bound to x.key in state
                            onChange={(e) => this.handleInputChange2(e, i)}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Value:</label>
                          <input
                            className="form-control"
                            name="giftValue"  // changed from "value"
                            placeholder="Enter Value"
                            value={x.value}   // still bound to x.value in state
                            onChange={(e) => this.handleInputChange2(e, i)}
                          />
                        </div>
                      </div>
                      <div className="col-md-2 pt-4">
                        {this.state.AddMoreGiftContractor.length !== 1 && (
                          <Button
                            icon="pi pi-times"
                            onClick={() => this.handleRemoveClick2(i)}
                            className="p-button-rounded p-button-danger p-button-text"
                          />
                        )}
                      </div>
                    </div>
                  );
                })}

              </div>
            </TabPanel>
          
          </TabView>
           <div className="col-md-12 text-center">
                  <Button label="Submit" icon="pi pi-check" onClick={this.submitForm} />
                </div>
        </Dialog>
              
        <Dialog
          header="Confirmation"
          visible={this.props.showIsActiveDialog}
          modal
          style={{ width: "350px" }}
          footer={renderFooter("displayConfirmation")}
          onHide={() => this.props.onHideShowIsActive(false)}
        >
          <div className="confirmation-content">
            <i
              className="pi pi-exclamation-triangle p-mr-3 confirm-icon"
              style={{ fontSize: "2rem" }}
            />
            <span>
              Are you sure you want to{" "}
              {this.state.switchAction == true ? "Active" : "InActive"}?
            </span>
          </div>
        </Dialog>
<Dialog
  visible={this.state.showContractorModal}
  onHide={() => this.setState({ showContractorModal: false })}
  header="Contractor Details"
  style={{ width: "40vw" }}
>
  {this.state.selectedContractors?.length ? (
    <div>
      {this.state.selectedContractors.map((c, index) => (
        <div
          key={c.id}
          style={{
            marginBottom: "1rem",
            borderBottom: "1px solid #eee",
            paddingBottom: "0.5rem",
          }}
        >
          {/* Serial number + contractor name */}
          <div style={{ fontWeight: "bold", fontSize: "14px" }}>
            {index + 1}. {c.name}
          </div>

          {/* Gifts list */}
          {c.gifts?.length ? (
            <ul style={{ margin: "0.5rem 0 0 1.5rem", padding: 0 }}>
              {c.gifts.map((g, i) => (
                <li key={i} style={{ fontSize: "13px", color: "#444" }}>
                  {g.key}: <strong>{g.value}</strong>
                </li>
              ))}
            </ul>
          ) : (
            <div style={{ fontSize: "12px", color: "#777", marginLeft: "1.5rem" }}>
              No gifts assigned
            </div>
          )}
        </div>
      ))}
    </div>
  ) : (
    <p>No contractors found.</p>
  )}
</Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    CategoryData: state.category.items,
    SubCategoryData: state.category.subItems,
    showDialog: state.category.showDialog,
    showDialog2: state.category.showDialog2,
    loading: state.category.loding,
    loading2: state.category.loding2,
    showIsActiveDialog: state.category.showIsActiveDialog,
    showIsActiveDialog2: state.category.showIsActiveDialog2,
    CategoryDataList: state.category.categoryddl,
    contractDDL: state.loyalityscheme.contractDDL || [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchApi: (obj) => {
      dispatch(ExtraBenefitMasterActions.getAll(obj));
    },
    SubCatefetchApi: (obj) => {
      dispatch(ExtraBenefitMasterActions.getSubAll(obj));
    },
    
    createCategory: (category, obj) =>
      dispatch(ExtraBenefitMasterActions.createCatagory(category, obj)),
    createContractor: (category, obj) =>
      dispatch(ExtraBenefitMasterActions.createContractor(category, obj)),
    updateContractor: (category) =>
      dispatch(ExtraBenefitMasterActions.updateContractor(category)),
    updateCategory: (category) =>
      dispatch(ExtraBenefitMasterActions.updateCategory(category)),
    SubUpdateCategory: (category) =>
      dispatch(ExtraBenefitMasterActions.SubUpdateCategory(category)),
    // createSubCategory: (category) =>
    //   dispatch(ExtraBenefitMasterActions.createSubCategory(category)),
    inActiveRow: (batchid, isActive, obj) =>
      dispatch(ExtraBenefitMasterActions.inActiveRow(batchid, isActive, obj)),
    inActiveRow2: (category, isActive) =>
      dispatch(ExtraBenefitMasterActions.inActiveRow2(category, isActive)),
    onHideShow: (isbool) =>
      dispatch(ExtraBenefitMasterActions.onHideShow(isbool)),
    onHideShow2: (isbool) =>
      dispatch(ExtraBenefitMasterActions.onHideShow2(isbool)),
    onHideShowIsActive: (isbool) =>
      dispatch(ExtraBenefitMasterActions.onHideShowIsActive(isbool)),
    onHideShowIsActive2: (isbool) =>
      dispatch(ExtraBenefitMasterActions.onHideShowIsActive2(isbool)),
    loadingData: (isLoding) =>
      dispatch(ExtraBenefitMasterActions.loadingData(isLoding)),
    loadingData2: (isLoding) =>
      dispatch(ExtraBenefitMasterActions.loadingData2(isLoding)),
    getCategoryDDL: (data) =>
      dispatch(ExtraBenefitMasterActions.getCategoryDDL(data, 1)),
    getContractorDDL: () => {
      dispatch(loyalityschemeActions.getContractorDDL());      
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ExtraBenefitMaster);